import { useState } from 'react';
import { taxForms } from '../../../mocks/taxForms';

export default function TaxFormsDirectory() {
  const [activeTab, setActiveTab] = useState<'individual' | 'business' | 'specialized'>('individual');

  const tabs = [
    { id: 'individual' as const, label: 'Individual Forms' },
    { id: 'business' as const, label: 'Business Forms' },
    { id: 'specialized' as const, label: 'Specialized' }
  ];

  return (
    <section id="forms" className="py-24 bg-white" aria-labelledby="forms-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 id="forms-heading" className="text-5xl font-bold text-gray-900 mb-4">
            <strong>Tax Forms Directory</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Access comprehensive guides and downloadable PDFs for all major US tax forms
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-gray-100 rounded-full p-2 gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'bg-gray-900 text-white shadow-lg'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {taxForms[activeTab].map((form: any) => (
            <div
              key={form.id}
              className={`bg-white border rounded-2xl p-6 hover:border-coral-500 hover:-translate-y-2 transition-all duration-300 shadow-sm hover:shadow-xl ${
                form.popular ? 'border-l-4 border-l-coral-500' : 'border-gray-200'
              }`}
            >
              {form.popular && (
                <span className="inline-block px-3 py-1 bg-coral-500 text-white text-xs font-semibold rounded-full mb-3">
                  Most Popular
                </span>
              )}
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{form.number}</h3>
              <h4 className="text-base font-semibold text-gray-700 mb-3">{form.name}</h4>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">{form.description}</p>
              <div className="flex gap-3">
                <a
                  href={form.pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap text-center cursor-pointer"
                >
                  Download PDF
                </a>
                <a
                  href={form.guideUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 px-4 py-2 text-teal-600 text-sm font-semibold hover:text-teal-700 transition-colors whitespace-nowrap text-center cursor-pointer"
                >
                  View Guide →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}